import React from "react";
import SEO from "../../../components/SEO";
import { Mail, Award } from "lucide-react";
import SunainaImg from "../../../assets/Sunaina.jpg";
import Testimonials from "../../../components/Testimonials";

const Sunaina = () => {

  const facts = [
    {
      title: "Études",
      backText:
        "Sunaina est titulaire d'un baccalauréat en commerce (avec mention) de l'Université d'Ottawa et d'une maîtrise en analytique de gestion de l'Université Queen's. Elle est également certifiée Professionnelle en gestion de projet (PMP)® et ceinture verte en Lean Six Sigma.",
    },
    {
      title: "Carrière",
      backText:
        "Sunaina Ahuja a rejoint einsured.ca en 2021, apportant plus de 10 ans d'expérience en tant qu'analyste, gestionnaire de projet et leader en technologie d'affaires acquise dans des rôles progressifs dans le secteur corporatif. Avant ce rôle, Sunaina a débuté son mandat chez einsured.ca comme conseillère en sécurité financière. En tant que l'une des premières employées d'einsured.ca, Sunaina a travaillé en étroite collaboration avec l'équipe de direction et les principales parties prenantes pour lancer des solutions d'assurance innovantes sur le marché.",
    },
    {
      title: "Jeunesse",
      backText:
        "Sunaina Ahuja est née le 24 janvier 1992, à Amritsar, Pendjab, Inde, dans une famille hindoue pendjabi. Elle a passé la majeure partie de son enfance à New Delhi. Sunaina et sa famille ont déménagé au Canada depuis l'Inde lorsqu'elle avait 13 ans. Elle a terminé ses études secondaires à l'École secondaire Rick Hansen.",
    },
    {
      title: "Loisirs",
      icon: <Award size={36} />,
      backText:
        "Dans ses temps libres, Sunaina aime lire les nouvelles, faire de la pâtisserie et passer du temps de qualité avec sa famille.",
    },
  ];

  return (
    <>
      <SEO
        title="Sunaina | COO et courtière d’assurance – einsured.ca"
        description="Découvrez Sunaina, COO et courtière d'assurance chez einsured.ca, offrant des conseils experts et des solutions personnalisées au Canada."
        keywords="Sunaina COO, courtière d'assurance Canada, direction einsured, conseillère en assurance experte, leader opérationnel services financiers"
        ogType="profile"
      />

      <section
        className="min-h-screen flex flex-col justify-center items-center px-6 sm:px-12 md:px-24 py-16"
        style={{ backgroundColor: "#f5f9ff" }}
      >
        <style>{`
          .flip-card {
            background-color: transparent;
            perspective: 1000px;
          }
          .flip-card-inner {
            position: relative;
            width: 100%;
            height: 260px;
            text-align: center;
            transition: transform 0.8s;
            transform-style: preserve-3d;
            border-radius: 24px;
            box-shadow: 0 15px 25px rgba(0, 0, 0, 0.15);
          }
          .flip-card:hover .flip-card-inner {
            transform: rotateY(180deg);
          }
          .flip-card-front,
          .flip-card-back {
            position: absolute;
            width: 100%;
            height: 100%;
            border-radius: 24px;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-family: "Montserrat", sans-serif;
            font-weight: 600;
          }
          .flip-card-front {
            background: linear-gradient(to bottom, #12a5dd, #3b4f80);
            color: white;
          }
          .flip-card-back {
            background: linear-gradient(to bottom, #3b4f80, #12a5dd);
            transform: rotateY(180deg);
            color: white;
            padding: 0 1.5rem;
          }

          /* Mobile polish for flip cards */
          @media (max-width: 640px) {
            .flip-card-inner {
              height: auto;
              min-height: 260px;
              transform: none !important;
            }
            .flip-card-front {
              display: none;
            }
            .flip-card-back {
              transform: none;
              padding: 1.25rem 1.25rem;
            }
          }
        `}</style>

        {/* TOP SECTION */}
        <div className="max-w-6xl w-full grid md:grid-cols-2 gap-12 items-start">
          {/* LEFT SIDE */}
          <div className="flex flex-col items-center md:items-start w-full">
            {/* Blue Box */}
            <div
              className="w-full rounded-t-[32px] px-8 py-6 text-center md:text-left shadow-md"
              style={{ backgroundColor: "#12a5dd", color: "white" }}
            >
              <h1 className="text-3xl sm:text-4xl font-bold mb-2">
                Sunaina Ahuja
              </h1>
              <p className="text-base sm:text-lg font-semibold">
                Directrice des opérations (COO) &amp; Courtière d'assurance
              </p>
            </div>
            <div
              className="w-full rounded-b-[32px] px-8 py-8 shadow-lg"
              style={{ backgroundColor: "#12a5dd", color: "white" }}
            >
              <p className="text-sm sm:text-base leading-relaxed mb-10 text-center md:text-left">
                Sunaina Ahuja est devenue COO en 2024 et se concentre sur la mise à l'échelle
                des opérations, le recrutement des meilleurs talents et la formation de partenariats
                stratégiques alors qu'einsured.ca se prépare pour sa prochaine phase de
                croissance. Ses priorités incluent l'attraction des meilleurs talents et
                le développement de partenariats stratégiques alors qu'einsured.ca se repositionne
                pour le prochain niveau de croissance.
              </p>

              {/* CONTACT */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6">
                <a
                  href="tel:+14165649000"
                  className="bg-white text-[#3b5180] font-medium text-base px-6 py-3 rounded-full shadow-md text-center"
                >
                  (416) 564-9000
                </a>

                <a
                  href="mailto:Sunaina@einsured.ca"
                  className="bg-white text-[#3b5180] font-medium text-base px-6 py-3 rounded-full shadow-md flex items-center justify-center gap-2 break-all sm:break-normal"
                >
                  <Mail className="w-4 h-4" />
                  Sunaina@einsured.ca
                </a>

                <a
                  href="tel:+14168400128"
                  className="bg-white text-[#3b5180] font-medium text-base px-6 py-3 rounded-full shadow-md text-center"
                >
                  (416) 840-0128 ext. 100
                </a>
              </div>
            </div>

            {/* Call Now */}
            <div className="text-center md:text-left mt-10 md:mt-12 w-full">
              <a
                href="https://book.einsured.ca/widget/bookings/ei-team"
                className="bg-[#3b4f80] hover:bg-[#2f3d66] text-white font-semibold px-10 py-3 rounded-full shadow-md transition w-full sm:w-auto inline-block text-center"
              >
                Prendre rendez-vous
              </a>
              <p className="text-sm mt-6">Consultations gratuites de 15 à 30 minutes.</p>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="flex justify-center md:justify-end mt-8 md:mt-0">
            <img
              src={SunainaImg}
              alt="Sunaina Ahuja"
              className="rounded-[32px] shadow-md w-full max-w-xs sm:max-w-sm h-[420px] object-cover object-top"
            />
          </div>
        </div>

        {/* FACTS */}
        <div className="mt-24 max-w-6xl w-full">
          <div className="text-center mb-12 px-2">
            <h2 className="text-3xl sm:text-5xl font-bold text-[#49628b] mb-4">
              Quelques faits sur Sunaina Ahuja
            </h2>
            <p className=" text-base sm:text-lg">
              Découvrez le profil de Sunaina pour mieux connaître ses domaines d'expertise et ses intérêts personnels.
            </p>
          </div>

          {/* Flip Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 max-w-5xl mx-auto">
            {facts.map((fact) => (
              <div key={fact.title} className="flip-card">
                <div className="flip-card-inner">
                  {/* FRONT */}
                  <div className="flip-card-front px-4">
                    {fact.icon && (
                      <div className="mb-3 flex justify-center">
                        {fact.icon}
                      </div>
                    )}
                    <h3 className="text-white text-2xl font-bold">
                      {fact.title}
                    </h3>
                  </div>

                  {/* BACK */}
                  <div className="flip-card-back flex px-4">
                    <p className="text-white text-sm sm:text-base leading-relaxed font-normal">
                      {fact.backText}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 4 EASY STEPS */}
      <section className="w-full flex justify-center bg-white py-16 sm:py-24 px-6 sm:px-12 md:px-24">
        <div className="max-w-6xl w-full grid md:grid-cols-2 gap-16 items-center">
          {/* LEFT SIDE TEXT */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <h2 className="text-3xl sm:text-5xl font-bold text-[#49628b] mb-5">
              4 étapes simples
            </h2>
            <p className="text-base sm:text-lg text-[#5f6f8f] mb-10 max-w-lg">
              Obtenez votre protection en quelques minutes et profitez d'une couverture d'assurance vie
              parfaitement adaptée à vos besoins.
            </p>

            <a
              href="tel:+14165649000"
              className="bg-[#3b4f80] hover:bg-[#2f3d66] text-white font-semibold px-12 py-3.5 rounded-full shadow-lg transition w-full sm:w-auto text-center"
            >
              Appelez maintenant !
            </a>
            <p className="text-sm  mt-4">Consultations gratuites de 15 à 30 minutes.</p>
          </div>

          {/* RIGHT SIDE */}
          <div className="bg-[#f5f8ff] rounded-[32px] shadow-lg px-6 sm:px-10 py-8 sm:py-10 md:px-14 md:py-12">
            <div className="relative pl-2 sm:pl-4">
              <div className="absolute left-6 sm:left-8 top-6 bottom-6 w-[2px] bg-[#3b4f80]/25"></div>

              {/* Step 1 */}
              <div className="flex items-start gap-4 sm:gap-6 mb-8 sm:mb-10 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">
                  1
                </div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">
                    Informations de base
                  </h3>
                  <p className="text-[#5f6f8f] text-sm md:text-base leading-relaxed">
                    Répondez à quelques questions de base pour nous aider à mieux vous connaître.
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-start gap-4 sm:gap-6 mb-8 sm:mb-10 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">
                  2
                </div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">
                    Analyse des besoins
                  </h3>
                  <p className="text-[#5f6f8f] text-sm md:text-base leading-relaxed">
                    Déterminez la couverture appropriée pour protéger vos proches.
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start gap-4 sm:gap-6 mb-8 sm:mb-10 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">
                  3
                </div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">
                    Questions de santé
                  </h3>
                  <p className="text-[#5f6f8f] text-sm md:text-base leading-relaxed">
                    Répondez à quelques questions liées à la santé pour obtenir un produit adapté à vos besoins.
                  </p>
                </div>
              </div>

              {/* Step 4 */}
              <div className="flex items-start gap-4 sm:gap-6 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">
                  4
                </div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">
                    Obtenez votre devis gratuit !
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default Sunaina;
